export default class LayoutBanners {
    static isClosed(id) {
        const closedBanners = localStorage.getItem(LayoutBanners.storageKey);
        if (closedBanners === null) {
            return false;
        }
        const data = LayoutBanners.getStorageData();
        const found = data.find((item) => {
            return item.id === id;
        });
        if (found) {
            const currentDateTimesStamp = new Date().getTime();
            if (found.closedTo && currentDateTimesStamp >= found.closedTo) {
                LayoutBanners.removeFromStorage(found.id);
                return false;
            }
            else {
                return true;
            }
        }
        return false;
    }
    static show(banner) {
        banner.style.display = 'flex';
    }
    static closeById(id, type) {
        if (!id || !type) {
            return;
        }
        const bannerCloseDays = LayoutBanners.getCloseDays(type);
        const data = LayoutBanners.getStorageData();
        let closedToTime = null;
        if (bannerCloseDays > 0) {
            const closedTo = new Date();
            closedTo.setDate(closedTo.getDate() + bannerCloseDays);
            closedToTime = closedTo.getTime();
        }
        if (data.length === 0) {
            localStorage.setItem(LayoutBanners.storageKey, JSON.stringify([{ id: id, closedTo: closedToTime }]));
        }
        else {
            const found = data.find((item) => {
                return item.id === id;
            });
            if (!found) {
                data.push({ id: id, closedTo: closedToTime });
                localStorage.setItem(LayoutBanners.storageKey, JSON.stringify(data));
            }
        }
    }
    static close(banner) {
        const dataSet = banner.dataset;
        const bannerId = dataSet.id;
        const type = dataSet.type;
        if (!bannerId || !type) {
            return;
        }
        LayoutBanners.closeById(Number(bannerId), Number(type));
        banner.style.display = 'none';
    }
    static getStorageData() {
        const raw = localStorage.getItem(LayoutBanners.storageKey);
        let data = [];
        if (raw !== null) {
            data = JSON.parse(raw);
        }
        return data;
    }
    static removeFromStorage(id) {
        const raw = localStorage.getItem(LayoutBanners.storageKey);
        let data = [];
        if (raw !== null) {
            data = JSON.parse(raw);
        }
        const filtered = data.filter((item) => {
            return item.id !== id;
        });
        localStorage.setItem(LayoutBanners.storageKey, JSON.stringify(filtered));
    }
    static getCloseDays(type) {
        let bannerCloseDays = 0;
        if (typeof window.__STATE__ !== 'undefined') {
            if (type === 1) {
                bannerCloseDays = window.__STATE__.functions.layout_banners_top_close_days;
            }
            else if (type === 2) {
                bannerCloseDays = window.__STATE__.functions.layout_banners_right_side_close_days;
            }
        }
        return bannerCloseDays;
    }
}
LayoutBanners.storageKey = 'layout_banners';
